<template>
  <base-selector
    v-model="selected"
    :search-function="search"
    :filter="filter"
    :label="label"
    :disabled="disabled"
    :rules="rules"
    no-data-text="Comece a digitar para buscar um evento"
  >
    <template v-slot:item="{ item }">
      <div class="d-flex flex-column py-1">
        <b>{{ item.name }}</b>
        <span class="text-caption">{{ item.date | date }}</span>
      </div>
    </template>
  </base-selector>
</template>

<script>
import PARTY from "@/services/admin/parties";
import BaseSelector from "./BaseSelector.vue";

export default {
  components: { BaseSelector },
  props: {
    value: {
      type: Object | null,
      required: true,
    },
    label: {
      type: String,
      default: "Selecione um evento",
    },
    take: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    async search(query) {
      const itens = await PARTY.search({ query, take: this.take });
      return itens.parties;
    },
    filter(item, query, itemText) {
      const { name, slug } = item;
      return (
        name.toLowerCase().includes(query.toLowerCase()) ||
        slug.toLowerCase().includes(query.toLowerCase())
      );
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
